export class Location {
    public name: string;
    public operatorName: string;
    public status: string;
    public number: string;
    public timezone: string;
    public latitude: number;
    public longitude: number;
    public address: string;
    public tempCloseFlag: boolean;
    public tempCloseReason: string;
    public closedDate: string;
}